<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<!-- Teacher/Admin View -->
<p-card *ngIf="!isStudent() && !loading; else studentView" header="Exams">
  <p-table
    #dt2
    [value]="filteredExamDetails"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    styleClass="p-datatable-striped p-datatable-gridlines p-datatable-sm"
    [rowsPerPageOptions]="[10, 25, 50]"
    [loading]="loading"
    [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['name', 'teachers', 'subjects', 'totalMarks', 'time']"
    [customSort]="true"
    (sortFunction)="customSort($event)"
  >
    <ng-template pTemplate="caption">
      <div class="flex">
        <button
          type="button"
          class="bg-primary border-primary-500 px-3 py-2 border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          (click)="onAddNew()"
        >
          Add New Exam
        </button>
        <app-download-template
          [sheets]="sheets"
          filename="exam-template"
          [allQuestions]="allQuestions"
          style="margin-left: 0.5rem"
        >
        </app-download-template>
        <app-upload-template
          [sheets]="sheets"
          (dataParsed)="handleParsedData($event)"
          style="margin-left: 0.5rem"
        >
        </app-upload-template>
        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="onGlobalFilter($event)"
            placeholder="Search keyword"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" style="width: 20%; min-width: 200px">
          Name<p-sortIcon field="name"></p-sortIcon>
          <p-columnFilter type="text" field="name" display="menu" />
        </th>
        <th style="width: 15%; min-width: 150px">Teachers</th>
        <th style="width: 15%; min-width: 150px">Subjects</th>
        <th pSortableColumn="totalMarks" style="width: 10%; min-width: 100px">
          Total Marks<p-sortIcon field="totalMarks"></p-sortIcon>
          <p-columnFilter type="text" field="totalMarks" display="menu" />
        </th>
        <th pSortableColumn="time" style="width: 8%; min-width: 80px">
          Time<p-sortIcon field="time"></p-sortIcon>
          <p-columnFilter type="text" field="time" display="menu" />
        </th>
        <th style="width: 12%; min-width: 120px">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-exam>
      <tr>
        <td style="max-width: 200px; word-wrap: break-word">
          <span [title]="exam.name">{{ exam.name }}</span>
        </td>
        <td style="max-width: 150px; word-wrap: break-word">
          <span [title]="getTeacherNames(exam.teachers)">{{ getTeacherNames(exam.teachers) }}</span>
        </td>
        <td style="max-width: 150px; word-wrap: break-word">
          <span [title]="getExamSubjects(exam)">{{ getExamSubjects(exam) }}</span>
        </td>
        <td class="text-center">{{ exam.totalMarks }}</td>
        <td class="text-center">{{ exam.time }} min</td>
        <td>
          <div class="flex align-items-center gap-1">
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-pencil"
              (click)="onEditExam(exam)"
              class="p-button-rounded p-button-text p-button-sm"
              title="Edit Exam"
            ></button>
            <div [title]="getDeleteButtonTitle(exam)">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-trash"
                (click)="onDeleteExam(exam.id)"
                [disabled]="isDeleteDisabled(exam)"
                [class]="
                  isDeleteDisabled(exam)
                    ? 'p-button-rounded p-button-text p-button-sm'
                    : 'p-button-rounded p-button-text p-button-danger p-button-sm'
                "
              ></button>
            </div>
            <p-button
              icon="pi pi-ellipsis-h"
              [rounded]="true"
              [text]="true"
              [raised]="true"
              pTooltip="More options"
              tooltipPosition="top"
              (click)="showMenu($event, exam)"
              class="menu-button"
            />
            <!-- Publish Button -->
            <!-- <div
              [title]="
                exam.isPublish ? 'View Dashboard' : 'Dashboard available only for published exams'
              "
            >
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-chart-bar"
                (click)="onViewDashboard(exam)"
                [disabled]="!exam.isPublish"
                [class]="
                  exam.isPublish
                    ? 'p-button-rounded p-button-text p-button-info p-button-sm'
                    : 'p-button-rounded p-button-text p-button-sm p-button-secondary'
                "
              ></button>
            </div>
            <div [title]="exam.isPublish ? 'View Exam Preview' : ''">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-eye"
                (click)="onTakeExam(exam)"
                [disabled]="!exam.isPublish"
                [class]="
                  exam.isPublish
                    ? 'p-button-rounded p-button-text p-button-info p-button-sm'
                    : 'p-button-rounded p-button-text p-button-sm p-button-secondary'
                "
              ></button>
            </div> -->
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center" style="padding: 1rem; color: #333">
          No exams found for this course.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<!-- Student View -->

<ng-template #studentView>
  <div class="page-wrapper">
    <div class="grid">
      <div class="col-12">
        <div
          class="flex font-bold shadow-2 text-blue-600 text-left text-lg p-1 border-round mb-1 mt-1"
        >
          <div class="col-6 mt-1">
            Exam List
            <span class="text-sm text-blue-800 p-2 border-round ml-2"
              >Total: {{ filteredExamDetails.length }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card card_gap">
      <p-dataView
        [value]="examDetails"
        [layout]="'grid'"
        [rows]="15"
        id="courses"
        [paginator]="true"
      >
        <ng-template pTemplate="header">
          <div class="grid grid-nogutter">
            <div class="col-12 md:col-6 mb-2">
              <span class="p-input-icon-left w-full">
                <i class="pi pi-search"></i>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="globalSearchQuery"
                  (input)="onFilterChange()"
                  placeholder="Search"
                  class="p-inputtext w-full"
                />
              </span>
            </div>
            <div class="col-12 md:col-6 text-right">
              <p-dropdown
                [options]="sortOptions"
                [(ngModel)]="selectedSort"
                (onChange)="onFilterChange()"
                placeholder="Sort By"
                styleClass="mr-2"
              >
              </p-dropdown>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="grid" let-examsData>
          <div id="grid-layout" class="grid grid-nogutter" [style.column-gap]="columnGap + '1rem'">
            <div
              id="card-layout"
              class="col-12 sm:col-6 md:col-4 xl:col-3 ind-card"
              *ngFor="let exam of examsData; let i = index"
            >
              <div
                #myCard
                class="border-1 surface-border surface-card border-round flex justify-content-between align-items-center mat-elevation-z10"
              >
                <div class="flex flex-column">
                  <h3>{{ exam.name }}</h3>
                  <div class="flex gap-2 mt-1">
                    <div>
                      <i class="pi pi-book" style="font-size: 1rem"></i> {{ exam.totalMarks }} Marks
                    </div>
                    |
                    <div>
                      <i class="pi pi-clock" style="font-size: 1rem"></i> {{ exam.time }} Mins
                    </div>
                    |
                    <div>Questions: {{ getExamTotalQuestions(exam) }}</div>
                    |
                    <div>Subject: {{ getExamSubjects(exam) }}</div>
                  </div>
                </div>
                <div class="flex gap-2 align-items-center">
                  <div
                    class="text-center p-1 border-round-sm"
                    [attr.title]="
                      isExamSubmitted(exam)
                        ? 'You have already submitted this exam'
                        : checkQuizDeadline(exam.deadlineDate)
                          ? 'Exam deadline has passed'
                          : 'Take Exam'
                    "
                  >
                    <p-button
                      [label]="isExamSubmitted(exam) ? 'Submitted' : 'Take Exam'"
                      [outlined]="true"
                      [severity]="isExamSubmitted(exam) ? 'success' : 'info'"
                      (click)="onTakeExam(exam)"
                      [disabled]="isExamSubmitted(exam) || checkQuizDeadline(exam.deadlineDate)"
                      [icon]="isExamSubmitted(exam) ? 'pi pi-check' : ''"
                    />
                  </div>
                  <div class="text-center p-1 border-round-sm">
                    <div
                      [title]="
                        canViewDashboard(exam)
                          ? 'View Dashboard'
                          : 'Dashboard available after submitting the exam or after the deadline'
                      "
                    >
                      <button
                        pButton
                        pRipple
                        type="button"
                        icon="pi pi-chart-bar"
                        (click)="onViewDashboard(exam)"
                        [disabled]="!canViewDashboard(exam)"
                        [class]="
                          canViewDashboard(exam)
                            ? 'p-button-rounded p-button-text p-button-info p-button-sm'
                            : 'p-button-rounded p-button-text p-button-sm p-button-secondary'
                        "
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
</ng-template>
<div *ngIf="loading" class="spinner-container">
  <div class="custom-spinner"></div>
</div>

<!-- Global Menu Component -->
<p-menu #globalMenu [model]="currentMenuItems" [popup]="true" appendTo="body" [baseZIndex]="10000">
  <ng-template let-item let-i="index" pTemplate="item">
    <button
      type="button"
      pButton
      [disabled]="item.disabled"
      [class]="item.buttonClass"
      [title]="item.tooltip"
      (click)="item.command?.()"
      style="display: flex; align-items: center; gap: 0.5rem"
    >
      <i [class]="item.icon"></i>
      <span style="text-align: left" [ngStyle]="{ color: item.textColor }">{{ item.label }}</span>
    </button>
  </ng-template>
</p-menu>
